var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('h1',{staticClass:"text-left ml-15 mt-2"},[_vm._v(_vm._s(_vm.gifts.name))]),_c('slot-machine-dp',{ref:"slot-machine",attrs:{"typeSlot":this.$route.name,"items":_vm.gifts}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }